import React, { useEffect, useState } from "react"
import toast from "react-hot-toast"

import {
   GetProductionLineDetails,
   SetProductionLineMould,
} from "api/api.service"
import { Button } from "components/Button"
import { Loader } from "components/Loader"
import { MoldColorConfiguration } from "constants"
import ProductionLineSkeleton from "../ProductionLineSkeleton/ProductionLineSkeleton"
import MouldConfigurationSkeleton from "../ProductionLineSkeleton/MouldConfigurationSkeleton"
import ChangeMouldSequenceModal from "./ChangeMouldSequenceModal"

const ProductionLineDetailsMoulds = props => {
   const { productionLineId, productionMouldDetails, isLoading, hasOrders } =
      props
   const [isOpen, setIsOpen] = useState(false)
   const [data, setData] = useState(null)
   const [isLocallyMutating, setIsLocallyMutating] = useState(false)
   useEffect(() => {
      const moulds = productionMouldDetails?.sort(
         (a, b) => a.sequence_number - b.sequence_number
      )
      setData(moulds)
   }, [isLoading])

   const handleFetchProductionMoulds = async () => {
      try {
         setIsLocallyMutating(true)
         const res = await GetProductionLineDetails(productionLineId)
         return res
      } catch (error) {
         history.push(APP_ROUTES.PRODUCTION_LINE_MANAGEMENT)
         toast.error("Production Line does not exist!")
      } finally {
         setIsLocallyMutating(false)
      }
   }

   const handleSubmit = async updatedRecord => {
      let payload = {
         productionLineId: Number(productionLineId),
         mouldCounfiguarations: [...updatedRecord],
      }

      try {
         setIsLocallyMutating(true)
         handleModalClose()
         await SetProductionLineMould(payload)
         const res = await handleFetchProductionMoulds()
         const moulds = res?.moulds?.sort(
            (a, b) => a.sequence_number - b.sequence_number
         )
         setData(moulds)
         // onSuccess()
         toast.success("Mould configuration has been changed")
      } catch (error) {
         console.error(error)
      } finally {
         setIsLocallyMutating(false)
      }
   }
   const handleModalClose = () => setIsOpen(prev => !prev)

   return (
      <>
         {isLoading ? (
            <ProductionLineSkeleton />
         ) : isLocallyMutating ? (
            <MouldConfigurationSkeleton />
         ) : (
            <div className="p-4">
               <div className="d-flex justify-content-between align-items-center w-full flex-wrap gap-3">
                  <div className="d-flex flex-column align-items-baseline w-100">
                     <h3 className="py-2">Mould Configuration</h3>

                     <div className="d-flex align-items-start justify-content-between w-100">
                        <div className="flex-grow-1">
                           <div className="d-flex justify-content-start gap-3 flex-wrap">
                              {data?.length ? (
                                 data?.map((color, ind) => {
                                    return (
                                       <div
                                          key={ind}
                                          className={`production-line-module mould-color mould-color-${color?.color?.toLowerCase()}`}
                                       >
                                          <p>
                                             {" "}
                                             {MoldColorConfiguration.getDisplayTextKey(
                                                color.color
                                             )}
                                          </p>
                                       </div>
                                    )
                                 })
                              ) : (
                                 <div className="mt-2">No Mould Added</div>
                              )}
                           </div>
                        </div>

                        {!hasOrders ? (
                           <div>
                              <Button
                                 className={`header-button headerButtonResponsive`}
                                 title="Change Sequence"
                                 onClick={() => setIsOpen(prev => !prev)}
                              />
                           </div>
                        ) : (
                           <></>
                        )}
                     </div>
                  </div>
               </div>
            </div>
         )}
         {isOpen && (
            <ChangeMouldSequenceModal
               isOpen={isOpen}
               onToggleModal={handleModalClose}
               onSave={handleSubmit}
               colors={data?.map(clr => ({
                  label: clr.color,
                  value: clr.color,
               }))}
               isLoading={false}
            />
         )}
      </>
   )
}

export default ProductionLineDetailsMoulds
